const Color = {
  Main: '#055C2D',
  Sub: '#1A4DBE',
  Normal: '#2C3655',
  Blur: '#673ab7',
  Warning: '#fff1d7',
  Dangerous: '#DC143C',
  Success: '#055C2D',
  Information: '#33ACFF',
  MixFirst: '#008386', 
  MixSecond: '#88CC01', 
  MixThird: '#b734b7',
  MixFourth: '#ce99bc',
  Button: '#ffffff',
  Hover: '#EFF5F5',
  Active: '#FF37A5',
  Line: '#ebebeb',
  Transfer: '#b74e4f',
  Receipt: '#05B955',
  IconFirst: '#808080',
  IconSecond: '#0b0b0b',
  Error: '#DC143C',
  MainBackGround: '#D5E5DA',
  Close:'#f44336'
}

export default Color;